<template>
  <div class="">
    <div class="layout-side-nav" :class="{ 'is-active': visibleSideNav }">
      <div class="bg-cover" @click="$emit('update:visibleSideNav', false)">
        닫기
      </div>
      <div class="side-nav-area">
        <div class="user-header-info-wrap">
          <div class="user-header-info-grp flex justify-c items-c">
            <i v-if="!isSocial" class="icon icon-phone-sm" />
            <i
              v-else-if="isSocial && user?.user_social_provider === 'naver'"
              class="icon icon-naver-sm"
            />
            <i
              v-else-if="isSocial && user?.user_social_provider === 'kakao'"
              class="icon icon-kakao-sm"
            />
            <p class="user-header-info f-s f-bk">
              {{ user?.user_id }}
            </p>
          </div>
          <p class="user-header-info-sm f-s f-bk">
            {{ user?.user_contact }}
          </p>
        </div>
        <div class="side-header-gnb-grp">
          <a
            class="side-header-1-depth f-normal f-m"
            @click="$router.push({ name: 'StaffEstimateListNew01' })"
          >
            홈
          </a>
          <a
            class="side-header-1-depth f-normal f-m"
            @click="$router.push({ name: 'StaffMypage' })"
          >
            마이페이지
          </a>
        </div>
        <button
          class="btn btn-logout w-full justify-e type-nav"
          @click="userLogout()"
        >
          로그아웃
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutSideNavStaff",
  props: {
    visibleSideNav: {
      type: Boolean,
    },
  },
};
</script>
